import { ContentWrapper } from './contact_us.styles';

export default function ContactUs() {
  return (
    <ContentWrapper>
      <p>
        Lajkonik. House of Bakery Sp. z o.o.
        <br />
        ul. Aleksandra Lubomirskiego 20
        <br />
        31-509 Kraków
      </p>

      <p>
        NIP 9442243141
        <br />
        KRS 0000412528
        <br />
        REGON 122524332
      </p>

      <h3>Dane kontaktowe</h3>

      <p>
        <strong>Dział obsługi klienta:</strong>
        <br />
        Adres email:{' '}
        <a href="mailto:piekarniaikawiarnia@lajkonik.com">piekarniaikawiarnia@lajkonik.com</a>
      </p>
    </ContentWrapper>
  );
}
